var vf = typeof window !== "undefined" ? window.vf : undefined;
if (!vf || typeof vf.vfunc !== "function") throw new Error("[vfunc-ui] load vfunc.js before this file.");
export default vf;
